import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Injector, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthActions } from '../../features/auth/state';
import { ToastService } from '../services/toast.service';

const PERMISSIONS_PATH = '/me/permissions';

export const forbiddenInterceptor: HttpInterceptorFn = (req, next) => {
  const injector = inject(Injector);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 403) {
        const translateService = injector.get(TranslateService);
        injector.get(ToastService).error(translateService.instant('errors.forbidden'));

        const requestUrl = new URL(req.url, environment.apiUrl);

        if (requestUrl.pathname !== PERMISSIONS_PATH) {
          injector.get(Store).dispatch(AuthActions.loadPermissions());
        }
      }

      return throwError(() => error);
    }),
  );
};
